import React from 'react'
import { createStackNavigator } from '@react-navigation/stack';
import BookingPage from '../../components/sideMenu/BookingPage';

const Stack = createStackNavigator()

const TabThreeStack = () => {
  return (
    <Stack.Navigator screenOptions={{
      headerShown: false,
    }}>
      <Stack.Screen name="Bookingpage" component={BookingPage}  options={{ title: 'golf-eq-app' }} />
    </Stack.Navigator>
  )
}

export default TabThreeStack